import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Heading, Spinner, Text, SimpleGrid, Input, InputGroup, InputLeftElement, Icon, Skeleton } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import Axios from '../utils/httpClient';
import Layout from './Layout';

const Kafedralar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');

  useEffect(() => {
    setLoading(true);
    Axios().get('api/v1/account/kafedralar/')
      .then(res => setItems(res?.data?.kafedralar || []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const s = String(q).toLowerCase().trim();
    if (!s) return items;
    return items.filter(i => String(i?.name || '').toLowerCase().includes(s));
  }, [items, q]);

  const ImageBox = ({ imageName, alt }) => {
    const [src, setSrc] = useState(imageName ? `/${imageName}` : '/logo.png');
    return (
      <img
        src={src}
        alt={alt}
        onError={() => setSrc('/logo.png')}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    );
  };

  return (
    <Layout>
      <Box p={6} maxW="1200px" mx="auto">
        <Box display='flex' justifyContent='space-between' alignItems='center' mb={4}>
          <Heading size='md'>Kafedralar</Heading>
          <InputGroup maxW='320px'>
            <InputLeftElement pointerEvents='none'>
              <Icon as={FiSearch} color='gray.400' />
            </InputLeftElement>
            <Input placeholder='Qidiring...' value={q} onChange={e => setQ(e.target.value)} bg='white' />
          </InputGroup>
        </Box>

        {loading ? (
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
            {Array.from({ length: 6 }).map((_, i) => (<Skeleton key={i} height='110px' borderRadius='12px' />))}
          </SimpleGrid>
        ) : (
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
            {filtered.map(k => (
              <Card key={k.id} p={6}
                _hover={{ boxShadow: 'xl', transform: 'translateY(-2px)', cursor: 'pointer' }}
                transition='all 0.18s ease-in-out'
                onClick={() => navigate(`/kafedra/${k.id}/teachers`)}>
                <Box display='flex' alignItems='center' gap={4}>
                  <Box w='64px' h='64px' borderRadius='12px' bg='teal.50' display='flex' alignItems='center' justifyContent='center' overflow='hidden'>
                    <ImageBox imageName={k.image_name} alt={k.name} />
                  </Box>
                  <Box>
                    <Text fontWeight={800} fontSize='lg'>{k.name}</Text>
                    <Text fontSize='sm' color='gray.500'>Kafedra</Text>
                  </Box>
                </Box>
              </Card>
            ))}
          </SimpleGrid>
        )}

        {!loading && !filtered.length ? (
          <Box mt={8} textAlign='center'>
            <Text color='gray.500'>Hech narsa topilmadi.</Text>
          </Box>
        ) : null}
      </Box>
    </Layout>
  );
};

export default Kafedralar; 